export const CONTROL_PANEL_SIDEBAR_TAG = "controlPanelSidebar";
export const MAIN_APP_SIDEBAR_TAG = "mainApplicationSidebar";
